import * as Images from 'pos/Images';

import { Modal } from 'core/ui-next/modal';
import { Res, TicketSummaryDTO } from 'core/api';
import { TicketSelection, SelectExistingTicket, SelectTicketScreen } from './SelectTicketScreen.Common';

const title = (tickets: TicketSummaryDTO[]) => {
	const saleCenter = tickets[0].SaleCenterName;
	const saleLocation = tickets[0].SaleLocationName;
	return Res.Web.GET_TICKET_IN_LOCATION(saleCenter, saleLocation);
};

const icon = () => Images.SelectTicketInLocation;

type UIParams = {
	title?: (tickets: TicketSummaryDTO[]) => string;
	icon?: () => string | SvgIcon;
	tickets: TicketSummaryDTO[];
};

export default async function selectTicket(uiParams: UIParams): Promise<Result<TicketSelection>>;
export default async function selectTicket(uiParams: UIParams, showCreateNewCommand: 'show-create-new-command', showTicketCommands: 'show-ticket-commands' | 'hide-ticket-commands'): Promise<Result<TicketSelection>>;
export default async function selectTicket(uiParams: UIParams, showCreateNewCommand: 'hide-create-new-command', showTicketCommands: 'show-ticket-commands' | 'hide-ticket-commands'): Promise<Result<SelectExistingTicket>>;
export default async function selectTicket(uiParams: UIParams, showCreateNewCommand: 'show-create-new-command' | 'hide-create-new-command' = 'show-create-new-command', showTicketCommands: 'show-ticket-commands' | 'hide-ticket-commands' = 'show-ticket-commands'): Promise<Result<TicketSelection>> {

	if (uiParams.tickets.length === 0) {
		throw new Error('No debería llegarse a esta pantalla si no hay tickets para elegir');
	}

	const titleFn = uiParams.title || title;
	const iconFn = uiParams.icon || icon;

	return Modal.show(SelectTicketScreen,
		{
			title: titleFn,
			icon: iconFn,
			showCreateNewCommand: showCreateNewCommand === 'show-create-new-command',
			showTicketCommands: showTicketCommands === 'show-ticket-commands',
			initialTickets: uiParams.tickets
		});
}